import {AfterViewInit, Component, OnInit} from '@angular/core';
import {CardAction} from "../../components/scotty-card/scotty-card.component";
import {Router} from "@angular/router";
import {Chip, OnlineStatus} from "../../components/list-view-element/list-view-element.component";
import {UiManagerService} from "../../services/ui-manager.service";
import {Personnel} from "../../models/personnel";
import {PersonnelManagerService} from "../../services/personnel-manager.service";
import {Skill} from "../../models/skill";
import {SkillManagerService} from "../../services/skill-manager.service";
import {Paginator} from "../../models/paginator";

@Component({
  selector: 'app-personnel-page',
  templateUrl: './personnel-page.component.html',
  styleUrls: ['./personnel-page.component.scss']
})
export class PersonnelPageComponent implements OnInit, AfterViewInit {

  isLoading = true;

  personnel: Personnel[] = [];
  personnelToShow = [];

  allSkills: Skill[];

  paginator: Paginator<Personnel>;

  constructor(
    public router: Router,
    private personnelManagerService: PersonnelManagerService,
    private uiManagerService: UiManagerService,
    private skillManagerService: SkillManagerService,
  ) { }

  ngOnInit() {
    this.paginator = new Paginator<Personnel>({ orderBy: 'lastName', sorting: 'ASC' });
  }

  async ngAfterViewInit(): Promise<void> {

    await this.fetchSkills();
    await this.fetchPersonnel();

    this.isLoading = false;

  }

  async fetchSkills() {
    this.allSkills = await this.skillManagerService.getAllSkills(new Paginator<Skill>({ ignorePagination: true }));
  }

  async fetchPersonnel() {

    this.paginator.onPageResults = (personnel: Personnel[]) => {
      this.personnel = personnel;
      this.personnelToShow = this.personnel.map((person: Personnel) => {
        return {
          uid: person.id,
          icon: 'person',
          name: `${person.lastName} ${person.firstName}`,
          email: person.email,
          online: person.available ? OnlineStatus.ONLINE : OnlineStatus.OFFLINE,
          fieldServices: [] as Chip[], //{text: 'Field service: H5', color: UiManagerService.colors[3] }
          skills: this.allSkills.filter(skill => person.skills_uid ? person.skills_uid.includes(skill.id) : false).map(skill => {
            return {text: skill.name, color: skill.color};
          }) as Chip[]
        };
      });
    }

    await this.personnelManagerService.getAllPersonnel(this.paginator);
  }

  getActions(): CardAction[] {
    return [
      { icon: 'add', name: 'New personnel', callback: () => { this.router.navigate(['personnel/create']) } },
    ];
  }

}
